import { styled } from "@linaria/react"


export const Faded = styled.div<{ size: number, backgroundColor: string }>`
  position: relative;

  &::before,
  &::after {
    position: absolute;
    right: 0;
    left: 0;

    z-index: 1;

    height: ${props => props.size}px;
    min-height: ${props => props.size}px;
    max-height: ${props => props.size}px;

    line-height: 0;

    pointer-events: none;
    content: "";
  }

  &::before {
    top: 0;

    background: linear-gradient(0deg, transparent, ${props => props.backgroundColor});
  }

  &::after {
    bottom: 0;

    background: linear-gradient(0deg, ${props => props.backgroundColor}, transparent);
  }
`